import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "apr-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "co-chip" }
const _hoisted_4 = { class: "co-val" }
const _hoisted_5 = { class: "grid-card" }
const _hoisted_6 = { class: "grid-head" }
const _hoisted_7 = { class: "ang" }
const _hoisted_8 = { class: "avatar" }
const _hoisted_9 = { class: "ang-nume" }
const _hoisted_10 = { class: "tip-badge" }
const _hoisted_11 = { class: "perioada" }
const _hoisted_12 = { class: "zile-badge" }
const _hoisted_13 = { class: "grid-card" }
const _hoisted_14 = { class: "grid-head" }
const _hoisted_15 = { class: "ang" }
const _hoisted_16 = { class: "avatar" }
const _hoisted_17 = { class: "ang-nume" }
const _hoisted_18 = { class: "tip-badge" }
const _hoisted_19 = { class: "perioada" }
const _hoisted_20 = { class: "zile-badge" }
const _hoisted_21 = { class: "grid-card" }
const _hoisted_22 = { class: "grid-head" }
const _hoisted_23 = { class: "ang" }
const _hoisted_24 = { class: "avatar" }
const _hoisted_25 = { class: "ang-nume" }
const _hoisted_26 = { class: "tip-badge tip-tichet" }
const _hoisted_27 = { class: "perioada" }
const _hoisted_28 = { class: "zile-badge" }
const _hoisted_29 = { class: "grid-card" }
const _hoisted_30 = { class: "grid-head" }
const _hoisted_31 = { class: "ang" }
const _hoisted_32 = { class: "avatar" }
const _hoisted_33 = { class: "ang-nume" }
const _hoisted_34 = { class: "zile-badge" }
const _hoisted_35 = { class: "dlg-ic" }
const _hoisted_36 = { class: "dlg-txt" }
const _hoisted_37 = { class: "dlg-title" }
const _hoisted_38 = { class: "dlg-desc" }
const _hoisted_39 = { class: "dlg-ic" }
const _hoisted_40 = { class: "dlg-txt" }
const _hoisted_41 = { class: "dlg-title" }
const _hoisted_42 = { class: "dlg-desc" }
const _hoisted_43 = { class: "dlg-head" }
const _hoisted_44 = { class: "dlg-ic" }
const _hoisted_45 = { class: "dlg-txt" }
const _hoisted_46 = { class: "dlg-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "hero-txt" }, [
        _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
        _createElementVNode("h1", { class: "hero-title" }, "Aprobări"),
        _createElementVNode("p", { class: "hero-sub" }, "Tot ce trebuie să acționezi: cereri de aprobat ca superior și confirmări ca înlocuitor.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "18",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("mdi-clipboard-check-outline", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.total), 1),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "co-lbl" }, "de rezolvat", -1))
      ])
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      class: "apr-tabs",
      color: "#ff5722",
      density: "comfortable"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "aprob" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("mdi-check-decagram-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode("De aprobat (" + _toDisplayString(_ctx.concedii.length) + ")", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "inl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("mdi-account-switch", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode("Înlocuiri concedii (" + _toDisplayString(_ctx.inlocuitor.length) + ")", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "inlt" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("mdi-ticket-confirmation-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode("Înlocuiri tichete (" + _toDisplayString(_ctx.tichete.length) + ") · info", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "decont" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("mdi-cash-multiple", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode("Deconturi (" + _toDisplayString(_ctx.deconturi.length) + ")", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode("mdi-check-decagram-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[21] || (_cache[21] = _createElementVNode("span", null, "Cereri de aprobat ca superior", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.concedii,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nu ai cereri de aprobat.'
      }, {
        angCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(data.data.NumeAngajat || 'Angajat'), 1)
          ])
        ]),
        tipCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(data.data.TipConcediu || 'CO'), 1)
        ]),
        perCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              size: "15",
              color: "#ff5722",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(data.data.PerioadaText), 1)
          ])
        ]),
        zileCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_12, _toDisplayString(data.data.NumarZile), 1)
        ]),
        aprobActCell: _withCtx(({ data }) => [
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-ok mr-1",
            variant: "flat",
            onClick: ($event: any) => (_ctx.openActiune(data.data, true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("mdi-check", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-no",
            variant: "flat",
            onClick: ($event: any) => (_ctx.openActiune(data.data, false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "angCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipConcediu",
            caption: "Tip",
            width: 120,
            "cell-template": "tipCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaText",
            caption: "Perioadă",
            width: 210,
            "cell-template": "perCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarZile",
            caption: "Zile",
            width: 70,
            alignment: "center",
            "cell-template": "zileCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Descriere",
            caption: "Descriere",
            "min-width": 150
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 200,
            "allow-filtering": false,
            "allow-sorting": false,
            "cell-template": "aprobActCell"
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.tab === 'aprob']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createTextVNode("mdi-account-switch-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[26] || (_cache[26] = _createElementVNode("span", null, "Concedii care așteaptă confirmarea ta ca înlocuitor", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.inlocuitor,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nicio solicitare de înlocuire.'
      }, {
        iAngCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(data.data.NumeAngajat || 'Coleg'), 1)
          ])
        ]),
        iTipCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_18, _toDisplayString(data.data.TipConcediu || 'CO'), 1)
        ]),
        iPerCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_icon, {
              size: "15",
              color: "#ff5722",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(data.data.PerioadaText), 1)
          ])
        ]),
        iZileCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_20, _toDisplayString(data.data.NumarZile), 1)
        ]),
        confActCell: _withCtx(({ data }) => [
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-ok",
            "prepend-icon": "mdi-check-circle",
            onClick: ($event: any) => (_ctx.openConfirm(data.data))
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode("Confirmă", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "iAngCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipConcediu",
            caption: "Tip",
            width: 120,
            "cell-template": "iTipCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaText",
            caption: "Perioadă",
            width: 210,
            "cell-template": "iPerCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarZile",
            caption: "Zile",
            width: 70,
            alignment: "center",
            "cell-template": "iZileCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Descriere",
            caption: "Descriere",
            "min-width": 150
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 140,
            "allow-filtering": false,
            "allow-sorting": false,
            "cell-template": "confActCell"
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.tab === 'inl']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
            _createTextVNode("mdi-ticket-confirmation-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[30] || (_cache[30] = _createElementVNode("span", null, "Tichete în care ești desemnat înlocuitor", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.tichete,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Niciun tichet.'
      }, {
        tAngCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_25, _toDisplayString(data.data.NumeAngajat || 'Coleg'), 1)
          ])
        ]),
        tTipCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_26, _toDisplayString(data.data.TipCerere || 'Tichet'), 1)
        ]),
        tPerCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_v_icon, {
              size: "15",
              color: "#ff5722",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(data.data.PerioadaText), 1)
          ])
        ]),
        tZileCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_28, _toDisplayString(data.data.ZileText), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "tAngCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipCerere",
            caption: "Tip cerere",
            width: 150,
            "cell-template": "tTipCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaText",
            caption: "Perioadă",
            width: 210,
            "cell-template": "tPerCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ZileText",
            caption: "Zile / Durată",
            width: 120,
            alignment: "center",
            "cell-template": "tZileCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DestinatieText",
            caption: "Destinație",
            "min-width": 140
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            caption: "Explicație",
            "min-width": 160
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.tab === 'inlt']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
            _createTextVNode("mdi-cash-multiple", -1)
          ]))]),
          _: 1
        }),
        _cache[33] || (_cache[33] = _createElementVNode("span", null, "Deconturi de aprobat", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.deconturi,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Niciun decont de aprobat.'
      }, {
        dAngCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_33, _toDisplayString(data.data.NumeAngajat || 'Angajat'), 1)
          ])
        ]),
        dTotalCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formatSuma(data.data.Total)), 1)
        ]),
        dActCell: _withCtx(({ data }) => [
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-ok mr-1",
            variant: "flat",
            onClick: ($event: any) => (_ctx.openActiuneDecont(data.data, true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                  _createTextVNode("mdi-check", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-no",
            variant: "flat",
            onClick: ($event: any) => (_ctx.openActiuneDecont(data.data, false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "dAngCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Numar",
            caption: "Număr",
            width: 120
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Data",
            caption: "Data",
            "data-type": "date",
            format: "dd.MM.yyyy",
            width: 120
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            caption: "Explicație",
            "min-width": 180
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Total",
            caption: "Total",
            width: 120,
            alignment: "right",
            "cell-template": "dTotalCell"
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 200,
            "allow-filtering": false,
            "allow-sorting": false,
            "cell-template": "dActCell"
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.tab === 'decont']
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dlgAprobDecont,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dlgAprobDecont) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["dlg-head", { no: !_ctx.aprobDecont }])
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.aprobDecont ? 'mdi-check-decagram' : 'mdi-close-octagon'), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.aprobDecont ? 'Aprobă decontul' : 'Respinge decontul'), 1),
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.selDecont?.NumeAngajat) + " · " + _toDisplayString(_ctx.selDecont?.Numar), 1)
              ]),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dlgAprobDecont = false))
              })
            ], 2),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.obsDecont,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.obsDecont) = $event)),
                  label: _ctx.aprobDecont ? 'Observație (opțional)' : 'Motiv respingere',
                  variant: "outlined",
                  density: "comfortable",
                  rows: "2",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dlgAprobDecont = false))
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: _normalizeClass([_ctx.aprobDecont ? 'btn-ok' : 'btn-no', "px-6"]),
                  loading: _ctx.act,
                  onClick: _ctx.confirmActiuneDecont
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.aprobDecont ? 'mdi-check' : 'mdi-close'), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.aprobDecont ? 'Aprobă' : 'Respinge'), 1)
                  ]),
                  _: 1
                }, 8, ["class", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dlgAprob,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dlgAprob) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["dlg-head", { no: !_ctx.aprob }])
            }, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.aprob ? 'mdi-check-decagram' : 'mdi-close-octagon'), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.aprob ? 'Aprobă cererea' : 'Respinge cererea'), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.sel?.NumeAngajat) + " · " + _toDisplayString(_ctx.sel?.PerioadaText), 1)
              ]),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dlgAprob = false))
              })
            ], 2),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.obs,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.obs) = $event)),
                  label: _ctx.aprob ? 'Observație (opțional)' : 'Motiv respingere',
                  variant: "outlined",
                  density: "comfortable",
                  rows: "2",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dlgAprob = false))
                }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: _normalizeClass([_ctx.aprob ? 'btn-ok' : 'btn-no', "px-6"]),
                  loading: _ctx.act,
                  onClick: _ctx.confirmActiune
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.aprob ? 'mdi-check' : 'mdi-close'), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(_ctx.aprob ? 'Aprobă' : 'Respinge'), 1)
                  ]),
                  _: 1
                }, 8, ["class", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dlgConf,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dlgConf) = $event)),
      "max-width": "460"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-account-check-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "dlg-title" }, "Confirmă înlocuirea", -1)),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.sel?.NumeAngajat) + " · " + _toDisplayString(_ctx.sel?.PerioadaText), 1)
              ]),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dlgConf = false))
              })
            ]),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.obs,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.obs) = $event)),
                  label: "Observație / explicație (opțional)",
                  variant: "outlined",
                  density: "comfortable",
                  rows: "2",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.dlgConf = false))
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-ok px-6",
                  loading: _ctx.act,
                  onClick: _ctx.confirmInlocuire
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("mdi-check-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[42] || (_cache[42] = _createTextVNode("Confirmă", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}